import {
  Divider,
  TextField,
  Grid,
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  ListSubheader,
  InputAdornment
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import PropTypes from 'prop-types';
import { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  addEmployee,
  addManagers,
  addNewSkill,
  addSkillsUser,
  getAllBillingRoles,
  getAllSkills,
  getAllBanks,
  uploadEmployeeDocsById,
  uploadEmployeeImageById,
  getLatestInternId,
  addBank,
  getAllGenders,
  getAllMartialStatus,
  getAllReportingManagers
} from 'src/services/employeeService';
import MuiPhoneNumber from 'material-ui-phone-number';
import { useForm } from 'react-hook-form';
import SearchIcon from '@mui/icons-material/Search';
import { AddEmployee, EmployeeInformation } from 'src/models/employee';
import { useDispatch } from 'react-redux';
import { AppActions } from 'src/store/AppReducer';
import './Employee.css';
import { getAllRoles } from 'src/services/RoleManagementService';
import { styled } from '@mui/material/styles';
import Rating from '@mui/material/Rating';
import CircleIcon from '@mui/icons-material/Circle';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import CancelIcon from '@mui/icons-material/Cancel';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import moment, { now } from 'moment';
import { useAppSelector } from 'src/hooks/hooks';
import { DatePicker } from '@mui/lab';
import Multiselect from 'multiselect-react-dropdown';
import { decryptResponseData } from 'src/utils/cryptoUtils';

const StyledRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: '#1bc47d'
  },
  '& .MuiRating-iconHover': {
    color: '#1bc47d'
  }
});

const filter = createFilterOptions<any>();

function EmployeeAddForm(props: any) {
  const TextFieldStyle = {
    paddingTop: 2,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '12px'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px',
    fontFamily:
      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
  };

  const selectStyle = {
    width: '94%',
    marginLeft: 15,
    marginTop: 5,
    paddingRight: 15,
    fontSize: '12px',
    height: '2.25rem'
  };

  const titleStyles = {
    fontWeight: '700',
    fontSize: '15px',
    fontFamily:
      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
  };

  const initalList: EmployeeInformation[] = [];
  const [employeeList, setEmployees] = useState(initalList);

  const [isNextSectionSelected, setNextSection] = useState(1);
  const { register, handleSubmit, reset, setValue ,getValues } = useForm<AddEmployee>();
  const [primaryManager, setPrimaryManager] = useState<any>({});
  const [secondaryManager, setSecondaryManager] = useState<any>({});
  const [additionalManager, setAdditionalManager] = useState<any>({});
  const [tableId, setTableId] = useState('');
  const [attachment, setAttachment] = useState<any>({});
  const [image, setImage] = useState<any>({});
  const [rating, setRating] = useState(1);
  const [userRoles, setUserRoles] = useState<any>([]);
  const [skill, setSkill] = useState<any>(null);
  const [bankValue, setBankValue] = useState<any>(null);
  const [allSkills, setAllSkills] = useState([]);
  const [allSkillsArr, setAllSkillsArr] = useState([]);
  const [addedSkills, setAddedSkills] = useState([]);
  const [duplicateError, setDuplicateError] = useState('');
  const [allBanks, setAllBanks] = useState([]);
  const [genders, setAllGenders] = useState([]);
  const [martialStatus, setAllMartialStatus] = useState([]);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const hasRunRef = useRef(false);

  const toggleConfirmation = () => {
    setOpenConfirmation(!openConfirmation);
  };

  const dispatch = useDispatch();

  const [billingRoles, setBillingRoles] = useState<any>([]);

  const getUserRoles = async () => {
    const roles = await getAllRoles();
    setUserRoles(roles?.data);
  };

  const isIndustrialExperienceValid = (value?: string) => {
    const regex =  /^\d+[Yy] \d+[Mm]$/;
    if (!value) {
      return false;
    }
    return value.length < 21 && regex.test(value);
  };

  useEffect(() => {
    getAllBillingRoles().then((res) => setBillingRoles(res.data));
    getUserRoles();
    getAllListData();
    getAllBanksDetails();
    getAllGenderDetails();
    getAllMartialStatusDetails();
    getReportingManagers();
  }, []);

  const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
  }

  useEffect(() => {
    if (!tableId) return;
    if (hasRunRef.current) return;

    hasRunRef.current = true;

    if (tableId) {
      if (!isEmpty(image)) {
        uploadEmployeeImageById(tableId, image.file);
      }
      if (!isEmpty(attachment)) {
        uploadEmployeeDocsById(tableId, attachment.file);
      }
      if (addedSkills.length > 0) {
        let allSkillsFiltered = [];
        allSkillsFiltered = addedSkills.map((ad) => {
          return {
            name: ad.name,
            level: ad.level,
            employeeId: tableId
          };
        });
        addSkillsUser(allSkillsFiltered);
      }

      handleClose();
      getData();
      dispatch(AppActions.hideLoader());
    }
  }, [tableId]);

  const addSkill = () => {
    if (allSkillsArr.includes(skill.title)) {
      if (!addedSkills.some((skill) => skill.name === skill.title)) {
        setDuplicateError('');
        setAddedSkills([
          ...addedSkills,
          { name: skill.title, level: rating, id: addedSkills.length + 1 }
        ]);
        setSkill(null);
        setRating(1);
      } else {
        setDuplicateError('Skill Already Exist');
      }
    } else {
      toggleConfirmation();
    }
  };

  const addSkillToList = () => {
    addNewSkill({ name: skill.title }).then((res) => {
      getAllListData();
    });
  };

  const getAllListData = () => {
    getAllSkills().then((res) => {
      setAllSkillsArr(res?.data);
      setAllSkills(
        res?.data.map((ele) => {
          return { title: ele };
        })
      );
    });
  };

  const getAllBanksDetails = () => {
    getAllBanks().then((res) => {
      setAllBanks(
        res?.data.map((ele) => {
          return { title: ele.name };
        })
      );
    });
  };
  const getAllGenderDetails = () => {
    getAllGenders().then((res) => {
      setAllGenders(
          res?.data.map((ele) => {
            return { title: ele.name, id: ele.id };
          })
      );
    });
  };

  const getAllMartialStatusDetails = () => {
    getAllMartialStatus().then((res) => {
      setAllMartialStatus(
          res?.data.map((ele) => {
            return { title: ele.name, id: ele.id };
          })
      );
    });
  };

  const { isLoading } = useAppSelector((state) => state.appReducer);

  const onSubmitEmployee = (data: AddEmployee) => {
    dispatch(AppActions.showLoader());

    setFirstPageValidation({});
    setSecondPageValidation({});
    setThirdPageValidation({});
    // const allData = {
    //   ...data,
    //   address: 'N/A',
    //   currentAddress: 'N/A',
    //   skypeID: 'N/A',
    //   phoneNumber: '+94770000000',
    //   emergencyContactNumber: '+94710000000',
    //   emergencyContactName: 'N/A',
    //   emergencyContactRelation: 'N/A'
    // };
    addEmployee(data, setTableId)
      .then(async (res) => {
        const createdEmployeeId =
          data?.employeeId || res?.data?.employeeId || res?.data?.employeeNumber;

        const managers = [];
        if (primaryManager?.ReporterId) {
          managers.push({
            EmployeeId: createdEmployeeId,
            ...primaryManager
          });
        }
        if (secondaryManager?.ReporterId) {
          managers.push({
            EmployeeId: createdEmployeeId,
            ...secondaryManager
          });
        }
        if (additionals.length > 0) {
          additionals.forEach((add) => {
            if (add.ReporterId) {
              managers.push({
                EmployeeId: createdEmployeeId,
                Level: add.Level,
                ReporterId: add.ReporterId
              });
            }
          });
        }

        if (managers.length > 0 && createdEmployeeId) {
          try {
            await addManagers(managers);
          } catch (error) {
            console.warn('Failed to save reporting manager:', error);
          }
        }

        reset();
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'Employee Added Successfully',
            severity: 'success'
          })
        );
        onClear();
        dispatch(AppActions.hideLoader());
      })
      .catch(() => {
        handleClose();
        dispatch(AppActions.hideLoader());
        dispatch(
          AppActions.toggleSnackBarOpen({
            message: 'Unable to add the Employee',
            severity: 'error'
          })
        );
         onClear();
      });
  };

  const [firstPageValidation, setFirstPageValidation] = useState<any>({});
  const [firstErrors, setFirstErros] = useState<any>({});

  const { onClose, open, getData } = props;

  useEffect(() => {
    setFirstPageValidation((prev) => ({
      ...prev,
      email: '@digiratina.com'
    }));
  }, [open]);

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(email)) {
      //Email valid. Procees to test if it's from the right domain (Second argument is to check that the string ENDS with this domain, and that it doesn't just contain it)
      if (
        email.indexOf(
          '@digiratina.com',
          email.length - '@digiratina.com'.length
        ) !== -1
      ) {
        //VALID
        return true;
      } else {
        return false;
      }
    }
  };

  const handleSubmitSectionOne = () => {
    const errorData: any = {};

    if (!firstPageValidation.name) {
      errorData.nameError = 'Name required';
    }
    else if (firstPageValidation.name?.trim()?.length < 1) {
      errorData.nameError = 'Employee Name cannot be only spaces';
    }
    if (
      !firstPageValidation.nic ||
      firstPageValidation.nic?.trim()?.length < 1
    ) {
      errorData.nicError = 'NIC required';
    }
    if (firstPageValidation?.nic?.length < 10) {
      errorData.nicError = 'NIC number cannot be less than 10';
    }
    if (!firstPageValidation.gender) {
      errorData.genderError = 'Gender required';
    }
    if (!firstPageValidation.martialStatus) {
      errorData.martialStatusError = 'Marital Status required';
    }
    if (!firstPageValidation.dob) {
      errorData.dobError = 'DOB required';
    }
    if (!firstPageValidation.phone) {
      errorData.phoneError = 'Phone required';
    }
    if (!firstPageValidation.ePhone) {
      errorData.ePhoneError = 'Emergency Contact Number is required';
    }

    if (
      !firstPageValidation.ePhoneName ||
      firstPageValidation.ePhoneName?.trim()?.length < 1
    ) {
      errorData.ePhoneNameError = 'Emergency Contact Name required';
    }
    else if(firstPageValidation.ePhoneName?.trim()?.length < 1) {
      errorData.ePhoneNameError = 'Emergency Contact Name cannot be only spaces';
    }
    if (!firstPageValidation.ePhoneRelation) {
      errorData.ePhoneRelationError = 'Emergency Contact Relation required';
    }
    else if(firstPageValidation.ePhoneRelation?.trim()?.length < 1) {
      errorData.ePhoneRelationError = 'Emergency Contact cannot be only spaces';
    }
    if (!firstPageValidation.address) {
      errorData.addressError = 'Address required';
    }
    else if(firstPageValidation.address?.trim()?.length < 1) {
      errorData.addressError = 'Address cannot be only spaces';
    }
    if (!firstPageValidation.cAddress) {
      errorData.cAddressError = 'Current Address is required';
    }
    else if(firstPageValidation.cAddress?.trim()?.length < 1){
      errorData.cAddressError = 'Current Address cannot be only spaces';
    }
    if (!firstPageValidation.email || firstPageValidation.email?.trim()?.length < 1) {
      errorData.emailError = 'Email required';
    }
    if (!validateEmail(firstPageValidation.email)) {
      errorData.emailError = 'Please Enter Valid Email Address';
    }
    setFirstErros(errorData);
    if (Object.keys(errorData).length === 0) {
      setNextSection(isNextSectionSelected + 1);
    }
  };

  const [secondPageValidation, setSecondPageValidation] = useState<any>({});
  const [secondErrors, setSecondErros] = useState<any>({});

  const handleSubmitSectionTwo = () => {
    const errorData: any = {};

    if (!secondPageValidation.designation) {
      errorData.designationError = 'Designation required';
    }
    if (
      !secondPageValidation.employeeId ||
      secondPageValidation.employeeId?.trim()?.length < 1
    ) {
      errorData.employeeIdError = 'Employee Id required';
    }
    if (!secondPageValidation.tier) {
      errorData.tierError = 'Tier required';
    }
    if (!secondPageValidation.joinedDate) {
      errorData.joinError = 'Joined Date required';
    }

    if (!secondPageValidation.employementType) {
      errorData.employementTypeError = 'Employement Type required';
    }
    if (!secondPageValidation.primaryManager) {
      errorData.primaryManagerError = 'Reporting Manager is required';
    }
    if (!secondPageValidation.from) {
      errorData.fromError = 'From Date required';
    }
    if (
      Date.parse(secondPageValidation.from) >=
      Date.parse(secondPageValidation.to)
    ) {
      errorData.toError = 'To date should be greater than from date';
    }
    setSecondErros(errorData);
    if (Object.keys(errorData).length === 0) {
      setNextSection(isNextSectionSelected + 1);
    }
  };

  const [thirdPageValidation, setThirdPageValidation] = useState<any>({});
  const [thirdErrors, setThirdErros] = useState<any>({});

  const checkArrayIncludes = (arr, obj) => {
    const titleValue = obj.title ? obj.title : obj;
    return arr.some((val) => val?.title === titleValue);
  };

  const onSubmit = (data: AddEmployee) => {
    // if (!checkArrayIncludes(allBanks, bankValue)) {
    //   addBank({ bankName: bankValue?.title })
    //     .then(() => {
    //       validateFinalData(data);
    //     })
    //     .catch((e) => {
    //       dispatch(
    //         AppActions.toggleSnackBarOpen({
    //           message: e.response.data || 'Unable to add bank name',
    //           severity: 'error'
    //         })
    //       );
    //     });
    // } else {
    //   validateFinalData(data);
    // }
    validateFinalData(data);
  };

  const validateFinalData = (data) => {
    const errorData: any = {};

    let allData: any = data;

    allData.bankName = bankValue?.title;
    allData.email = firstPageValidation?.email;
    allData.phoneNumber = firstPageValidation?.phone;
    allData.emergencyContactNumber = firstPageValidation?.ePhone;
    allData.emergencyContactName = firstPageValidation?.ePhoneName;
    allData.emergencyContactRelation = firstPageValidation?.ePhoneRelation;

    const employeeNumberValue = secondPageValidation?.employeeId;

    allData.employeeId = employeeNumberValue;
    allData.employeeNumber = employeeNumberValue;
    allData.tier = secondPageValidation?.tier;
    allData.EmployeeTypeEndingDate = secondPageValidation.to ? secondPageValidation.to : null; 
    allData.carrierStartDate = secondPageValidation?.carrierStartDate ? secondPageValidation?.carrierStartDate : null;

  delete allData.genderId;
  delete allData.maritalStatusId;
 

    if (!thirdPageValidation.userRole) {
      errorData.userRoleError = 'User Role is required';
    }
    // if (!thirdPageValidation.bankName) {
    //   errorData.bankNameError = 'Bank name is required';
    // }
    // if (
    //   !thirdPageValidation.branch ||
    //   thirdPageValidation.branch?.trim()?.length < 1
    // ) {
    //   errorData.branchError = 'Branch name is required';
    // }

    // if (!thirdPageValidation.branchCode) {
    //   errorData.branchCodeError = 'Branch code required';
    // }

    // if (
    //   !thirdPageValidation.accountName ||
    //   thirdPageValidation.accountName?.trim()?.length < 1
    // ) {
    //   errorData.accountNameError = 'Account name is required';
    // }

    // if (!thirdPageValidation.accountNumber) {
    //   errorData.accountNumberError = 'Account number is required';
    // }
    setThirdErros(errorData);
    if (Object.keys(errorData).length === 0) {
      onSubmitEmployee(allData);
    }
  };

  // clear set values
  const onClear = ( () => {
    setSelectedGender('');
    setSelectedMaritalStatus('');
    setFirstPageValidation((prev) => ({
      ...prev,
      email: '@digiratina.com'
    })); 
    setFirstPageValidation((prev) => ({
      ...prev,
      name: ''
    }));
    setFirstPageValidation((prev) => ({
      ...prev,
      nic: ''
    }));
    setFirstPageValidation((prev) => ({
      ...prev,
      dob: ''
    }));
    setFirstPageValidation((prev) => ({
      ...prev,
      phone: ''
    }));
    setFirstPageValidation((prev) => ({
      ...prev,
      ePhone: ''
    }));
    setFirstPageValidation((prev) => ({
      ...prev,
      address: ''
    }));
    setFirstPageValidation((prev) => ({
      ...prev,
      cAddress: ''
    }));
    setFirstPageValidation((prev) => ({
      ...prev,
      skypeId: ''
    }));
    setFirstPageValidation((prev) => ({
      ...prev,
      ePhoneName: ''
    }));
    setFirstPageValidation((prev) => ({
      ...prev,
      ePhoneRelation: ''
    }));
    setSecondPageValidation((prev) => ({
      ...prev,
      tier: ''
    }));
    setSelectedOption('');
    setSecondPageValidation((prev) => ({
      ...prev,
      designation: ''
    }));
    setSecondPageValidation((prev) => ({
      ...prev,
      employeeId: ''
    }));
    setEmployeeId('')
    setSecondPageValidation((prev) => ({
      ...prev,
      joinedDate: ''
    }));
    setSecondPageValidation((prev) => ({
      ...prev,
      carrierStartDate: ''
    }));
    setSecondPageValidation((prev) => ({
      ...prev,
      employementType: ''
    }));
    setSecondPageValidation((prev) => ({
      ...prev,
      primaryManager: ''
    }));
    setSelectedType('');
    setPrimaryManager({
      ReporterId: '',
      Level: 'primary'
    });
    setSelectedReporter('');
    setSecondPageValidation((prev) => ({
      ...prev,
      from: ''
    }));
    setSecondPageValidation((prev) => ({
      ...prev,
      to: ''
    }));
    setThirdPageValidation((prev) => ({
      ...prev,
      bankName: ''
    }));
    setBankValue({
      title: ''
    });
    setThirdPageValidation((prev) => ({
      ...prev,
      branchCode: ''
    }));
    setThirdPageValidation((prev) => ({
      ...prev,
      branch: ''
    }));
    setThirdPageValidation((prev) => ({
      ...prev,
      accountName: ''
    }));
    setThirdPageValidation((prev) => ({
      ...prev,
      accountNumber: ''
    }));
    setThirdPageValidation((prev) => ({
      ...prev,
      userRole: ''
    }));
    //setSelectedUserRole('');
    setAddedSkills([]);
    setSkill({
      title: ''
    });
    setRating(1);
  })

  //clear set errors
  const onClearErrors = () => {
    setFirstErros((prev) => ({
      ...prev,
      nameError: ''
    }));
    setFirstErros((prev) => ({
      ...prev,
      nicError: ''
    }));
    setFirstErros((prev) => ({
      ...prev,
      genderError: ''
    }));
    setFirstErros((prev) => ({
      ...prev,
      martialStatusError: ''
    }));
    setFirstErros((prev) => ({
      ...prev,
      dobError: ''
    }));
    setFirstErros((prev) => ({
      ...prev,
      phoneError: ''
    }));
    setFirstErros((prev) => ({
      ...prev,
      ePhoneError: ''
    }));
    setFirstErros((prev) => ({
      ...prev,
      addressError: ''
    }));
    setFirstErros((prev) => ({
      ...prev,
      cAddressError: ''
    }));
    setFirstErros((prev) => ({
      ...prev,
      skypeIdError: ''
    }));
    setFirstErros((prev) => ({
      ...prev,
      emailError: ''
    }));
    setFirstErros((prev) => ({
      ...prev,
      ePhoneNameError: ''
    }));
    setFirstErros((prev) => ({
      ...prev,
      ePhoneRelationError: ''
    }));
    setSecondErros((prev) => ({
      ...prev,
      designationError: ''
    }));
    setSecondErros((prev) => ({
      ...prev,
      employeeIdError: ''
    }));
    setSecondErros((prev) => ({
      ...prev,
      joinError: ''
    }));
    setSecondErros((prev) => ({
      ...prev,
      previousExperienceError: ''
    }));
    setSecondErros((prev) => ({
      ...prev,
      employementTypeError: ''
    }));
    setSecondErros((prev) => ({
      ...prev,
      primaryManagerError: ''
    }));
    setSecondErros((prev) => ({
      ...prev,
      fromError: ''
    }));
    setSecondErros((prev) => ({
      ...prev,
      toError: ''
    }));
    setThirdErros((prev) => ({
      ...prev,
      bankNameError: ''
    }));
    setThirdErros((prev) => ({
      ...prev,
      branchCodeError: ''
    }));
    setThirdErros((prev) => ({
      ...prev,
      branchError: ''
    }));
    setThirdErros((prev) => ({
      ...prev,
      accountNameError: ''
    }));
    setThirdErros((prev) => ({
      ...prev,
      accountNumberError: ''
    }));
    setThirdErros((prev) => ({
      ...prev,
      userRoleError: ''
    }));
  };

  const handleBackClick = () => {
    setNextSection(isNextSectionSelected - 1);
  };

  const handleClose = () => {
    setFirstPageValidation({});
    setSecondPageValidation({});
    setThirdPageValidation({});
    reset();
    setAttachment({});
    setImage({});
    onClear();
    onClearErrors();
    setNextSection(1);
    onClose();
  };

  const changeHandler = (event) => {
    const fileSize = (event.target.files[0].size / 1024 / 1024).toFixed(4);
    const imageName = event.target.files[0].name;
    const extensionsRegex =
      /(\.pdf|\.xls|\.xlsx|\.doc|\.docx|\.png|\.jpeg|\.jpg)$/i;
    if (Number(fileSize) > 10) {
      setFirstErros((prev) => ({
        ...prev,
        attachmentError: 'Maximum file size exceeded.'
      }));
    } else if (!extensionsRegex.exec(imageName)) {
      setFirstErros((prev) => ({
        ...prev,
        attachmentError: 'File format is incorrect. Please check and try again.'
      }));
    } else {
      setFirstErros((prev) => ({
        ...prev,
        attachmentError: ''
      }));
      setAttachment({ file: event.target.files[0] });
    }
  };

  const handleImageChange = (event) => {
    const fileSize = (event.target.files[0].size / 1024 / 1024).toFixed(4);
    const imageName = event.target.files[0].name;
    const extensionsRegex = /(\.jpg|\.jpeg|\.bmp|\.gif|\.png)$/i;

    if (Number(fileSize) > 10) {
      setFirstErros((prev) => ({
        ...prev,
        imageError: 'Maximum file size exceeded.'
      }));
    } else if (!extensionsRegex.exec(imageName)) {
      setFirstErros((prev) => ({
        ...prev,
        imageError: 'File format is incorrect. Please check and try again.'
      }));
    } else {
      setFirstErros((prev) => ({
        ...prev,
        imageError: ''
      }));
      setImage({ file: event.target.files[0] });
    }
  };

  const shuffle = (string) => {
    var array = string.split('');
    var tmp,
      current,
      top = array.length;

    if (top)
      while (--top) {
        current = Math.floor(Math.random() * (top + 1));
        tmp = array[current];
        array[current] = array[top];
        array[top] = tmp;
      }

    return array.join('');
  };

  const [additionals, setAdditionals] = useState([]);
  const onlyAlphanumericRegex = /[^a-z0-9]/gi;

  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

  const [selectedOption, setSelectedOption] = useState('');
  const [searchText, setSearchText] = useState('');

  const displayedOptions = useMemo(
    () =>
      billingRoles.length > 0 &&
      billingRoles?.filter((option) => containsText(option.name, searchText)),
    [searchText, billingRoles]
  );

  const getReportingManagers = async () => {
    try {
      const res = await getAllReportingManagers();
      const decryptedData: any = await decryptResponseData(res.data);
      setEmployees(
        (decryptedData?.employees as EmployeeInformation[]) || []
      );
    } catch (error) {
      console.error('Error fetching reporting managers:', error);
    }
  };

  const displayedReportingManagers = useMemo(
    () =>
    employeeList.length > 0 &&
    employeeList?.filter((option) => containsText(option.name, searchText)),
    [searchText, employeeList]
  );

  const [isAutoFilled, setIsAutoFilled] = useState(false);

  const getLatestInternIdValue = async () => {
    const result = await getLatestInternId();
    const value = result.data.replace(/\D/g, '');

    const padLeft = (nr?: any, n?: any, str?: any) => {
      return Array(n - String(nr).length + 1) + nr;
    };

    const generatedId = `T-${padLeft(Number(value) + 1, 3)?.replace(',', '')}`;
    setSecondPageValidation((prev) => ({
      ...prev,
      employeeId: generatedId
    }));
  };

  const empIdAutoFill = useCallback(() => {
    setIsAutoFilled(true);
    getLatestInternIdValue();
  }, []);

  useEffect(() => {
    const designationValue = secondPageValidation.designation;
    const splitDesignation = designationValue?.split(' ')[0];

    if (splitDesignation && splitDesignation === 'Intern') {
      empIdAutoFill();
    } else {
      setIsAutoFilled(false);
    }
  }, [empIdAutoFill, secondPageValidation.designation]);

  const [selectedGender, setSelectedGender] = useState('');
  const [selectedMaritalStatus, setSelectedMaritalStatus] = useState('');
  const [selectedReporter, setSelectedReporter] = useState('');
  const [selectedType, setSelectedType] = useState('');
  //const [selectedUserRole, setSelectedUserRole] = useState('');
  const [employeeId, setEmployeeId] = useState('');

  const subtractYears = (date, years) => {
    date.setFullYear(date.getFullYear() - years);
    return date;
  }

  const handleDateClick = () => {
    if(!firstPageValidation?.dob || firstPageValidation?.dob == 'Invalid date') {
      setFirstPageValidation((prev) => ({
        ...prev,
        dob: subtractYears(new Date(), 16)
      }));
    }
  }

  const onSelect = (selectedList, selectedItem) => {
    //setSelectedUserRole(selectedList.map((sel) => sel.name).join(','));
    setValue('role', selectedList.map((sel) => sel.name).join(','));
    setThirdErros((prev) => ({
      ...prev,
      userRoleError: ''
    }));
    setThirdPageValidation((prev) => ({
      ...prev,
      userRole: selectedList.map((sel) => sel.name).join(',')
    }));
  };

  const onRemove = (selectedList, selectedItem) => {
    if (selectedItem.name === 'General User') {
      const generalUser = userRoles.find((e) => e.name === 'General User');
      if (generalUser && !selectedList.some((r) => r.name === 'General User')) {
        selectedList.unshift(generalUser);
      }
    }
    if(selectedList.length === 0){
      setThirdErros((prev) => ({
        ...prev,
        userRoleError: 'User Role is required'
      }));
    } else {
      setThirdErros((prev) => ({
        ...prev,
        userRoleError: ''
      }));
    }
    //setSelectedUserRole(selectedList.map((sel) => sel.name).join(','))
    setValue('role', selectedList.map((sel) => sel.name).join(','));
    setThirdPageValidation((prev) => ({
      ...prev,
      userRole: selectedList.map((sel) => sel.name).join(',')
    }));
  };

  const setSelectedRoles = () => {
    const roles = [];
    const currentRoles = getValues('role');
    if (currentRoles) {
      currentRoles.split(',').forEach((name) => {
        const roleObj = userRoles.find((r) => r.name === name);
        if (roleObj) roles.push(roleObj);
      });
    }
    const generalUser = userRoles.find((e) => e.name === 'General User');
    if (generalUser && !roles.some((r) => r.name === 'General User')) {
      roles.unshift(generalUser);
    }
    return roles;
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={handleClose}
      className='employee-add'
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        {isNextSectionSelected === 1 && (
          <>
            <Grid
              item
              xs={12}
              style={{ marginTop: '2rem' }}
              sx={{ mt: 5, pb: 2, pl: 2 }}
            >
              <Typography style={titleStyles}>General Details</Typography>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '13px',
                    fontFamily:
                      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
                  }}
                  fontWeight="light"
                  variant="h5"
                >
                  Employee Name<span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  id="name"
                  size="small"
                  {...register('name', {})}
                  style={TextFieldStyle}
                  fullWidth
                  placeholder="Employee Name"
                  InputProps={{
                    style: { fontSize: '12px', height: '2.25rem' }
                  }}
                  variant="outlined"
                  value={firstPageValidation.name}
                  onChange={(e) => {
                    if (e.target.value.length < 51) {
                      setFirstPageValidation((prev) => ({
                        ...prev,
                        name: e.target.value
                      }));
                      setFirstErros((prev) => ({
                        ...prev,
                        nameError: ''
                      }));
                    }
                  }}
                />
                {firstErrors?.nameError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {firstErrors?.nameError}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={6}>
                <Typography
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '13px',
                    fontFamily:
                      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
                  }}
                  fontWeight="light"
                  variant="h5"
                >
                  NIC<span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  size="small"
                  id="nic"
                  {...register('nic', {})}
                  InputProps={{
                    style: { fontSize: '12px', height: '2.25rem' }
                  }}
                  style={TextFieldStyle}
                  fullWidth
                  placeholder="Enter NIC"
                  variant="outlined"
                  value={firstPageValidation.nic}
                  onChange={(e) => {
                    e.target.value = e.target.value.replace(
                      onlyAlphanumericRegex,
                      ''
                    );
                    if (e.target.value.length < 13) {
                      setFirstErros((prev) => ({
                        ...prev,
                        nicError: ''
                      }));
                      setFirstPageValidation((prev) => ({
                        ...prev,
                        nic: e.target.value
                      }));
                    }
                  }}
                />
                {firstErrors?.nicError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {firstErrors?.nicError}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={6}>
                <Typography
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '13px',
                    fontFamily:
                      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
                  }}
                  fontWeight="light"
                  variant="h5"
                >
                  Gender<span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl fullWidth>
                  <Select
                    size="small"
                    style={selectStyle}
                    defaultValue={''}
                    displayEmpty
                    id="gender"
                    value={selectedGender}
                    {...register('gender', {})}
                    onChange={(e) => {
                      setFirstErros((prev) => ({
                        ...prev,
                        genderError: ''
                    }));
                      setFirstPageValidation((prev) => ({
                        ...prev,
                        gender: e.target.value
                      }));
                      setSelectedGender(e.target.value)
                    }}
                  >
                    <MenuItem
                      style={{ display: 'none' }}
                      selected
                      disabled
                      value={''}
                    >
                      Select Gender
                    </MenuItem>
                   {genders.map((gnd) => (
                        <MenuItem
                            key={gnd.id}
                            value={gnd.title}
                        >
                          {gnd.title}
                        </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {firstErrors?.genderError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {firstErrors?.genderError}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={6}>
                <Typography
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '13px',
                    fontFamily:
                      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
                  }}
                  fontWeight="light"
                  variant="h5"
                >
                  Marital Status<span style={{ color: 'red' }}>*</span>
                </Typography>
                <Select
                  size="small"
                  style={selectStyle}
                  defaultValue={''}
                  displayEmpty
                  label="Marital Status"
                  id="maritalStatus"
                  {...register('maritalStatus', {})}
                  value={selectedMaritalStatus}
                  onChange={(e) => {
                    setFirstErros((prev) => ({
                      ...prev,
                      martialStatusError: ''
                    }));
                    setFirstPageValidation((prev) => ({
                      ...prev,
                      martialStatus: e.target.value
                    }));
                    setSelectedMaritalStatus(e.target.value)
                  }}
                >
                  <MenuItem
                    style={{ display: 'none' }}
                    selected
                    disabled
                    value={''}
                  >
                    Select Martial Status
                  </MenuItem>
                  {martialStatus.map((ms) => (
                      <MenuItem
                          key={ms.id}
                          value={ms.title}
                      >
                        {ms.title}
                      </MenuItem>
                  ))}
                </Select>
                {firstErrors?.martialStatusError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {firstErrors?.martialStatusError}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={6}>
                <Typography
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '13px',
                    fontFamily:
                      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
                  }}
                  fontWeight="light"
                  variant="h5"
                >
                  Date of Birth<span style={{ color: 'red' }}>*</span>
                </Typography>
                <div style={{ marginLeft: 12, marginRight: 13, marginTop: 2 }}>
                  <FormControl fullWidth>
                    <DatePicker
                      InputProps={{
                        className: 'date-picker',
                        onClick: handleDateClick, // Add onClick event handler
                      }}
                      maxDate={subtractYears(new Date(), 16)}
                      renderInput={(params) => (
                        <TextField {...params} id="dob"/>
                      )}
                      value={ firstPageValidation?.dob ? firstPageValidation.dob : '' }
                      onChange={(newValue) => {
                        if (newValue) {
                          setFirstErros((prev) => ({
                            ...prev,
                            dobError: ''
                          }));
                          setFirstPageValidation((prev) => ({
                            ...prev,
                            dob: moment(newValue).format('YYYY-MM-DD')
                          }));
                          setValue('dob', moment(newValue).format('YYYY-MM-DD'))
                        }
                      }}
                    />
                  </FormControl>
                </div>
                {firstErrors?.dobError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {firstErrors?.dobError}
                  </Typography>
                )}
              </Grid>
              <Fragment>
                <Grid item xs={4}>
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '13px',
                      fontFamily:
                        'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
                    }}
                    fontWeight="light"
                    variant="h5"
                  >
                    Add Attachment
                  </Typography>
                  <TextField
                    id="attachment"
                    style={TextFieldStyle}
                    InputProps={{
                      style: { fontSize: '12px', height: '2.25rem' }
                    }}
                    fullWidth
                    size="small"
                    placeholder="No file Selected"
                    value={
                      Object.keys(attachment).length === 0
                        ? ''
                        : attachment?.file?.name
                    }
                  />
                  <p
                    style={{
                      marginLeft: '1.75rem',
                      marginTop: 0,
                      marginBottom: 0,
                      fontSize: '0.6rem',
                      height: '0rem'
                    }}
                  >
                    Maximum file upload size: 10MB
                  </p>
                  {firstErrors?.attachmentError && (
                    <Typography
                      style={{
                        paddingLeft: 15,
                        paddingRight: 15,
                        fontSize: '11px',
                        marginTop: '0.75rem'
                      }}
                      color="red"
                    >
                      {firstErrors?.attachmentError}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={2}>
                  <Button
                    id="btn-changeHandler"
                    style={{
                      marginTop: '1.2rem',
                      border: '1px solid #5569ff',
                      marginLeft: '-0.5rem',
                      color: '#5569ff',
                      padding: '6px 8px',
                      borderRadius: '6px',
                      fontSize: '13px',
                      fontWeight: 'normal'
                    }}
                  >
                    Choose
                    <input
                      type="file"
                      name="attachment"
                      id="upload-attachment"
                      accept=".pdf, .xls, .xlsx, .doc, .docx, .png, .jpeg, .jpg"
                      onChange={changeHandler}
                    />
                  </Button>
                </Grid>
              </Fragment>
              <Fragment>
                <Grid item xs={4}>
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '13px',
                      fontFamily:
                        'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
                    }}
                    fontWeight="light"
                    variant="h5"
                  >
                    Add Profile Photo
                  </Typography>
                  <TextField
                    id="image"
                    style={TextFieldStyle}
                    InputProps={{
                      style: { fontSize: '12px', height: '2.25rem' }
                    }}
                    fullWidth
                    size="small"
                    placeholder="No image Selected"
                    value={
                      Object.keys(image).length === 0 ? '' : image?.file?.name
                    }
                  />
                  <p
                    style={{
                      marginLeft: '1.75rem',
                      marginTop: 0,
                      marginBottom: 0,
                      fontSize: '0.6rem',
                      height: '0rem'
                    }}
                  >
                    Maximum file upload size: 10MB
                  </p>
                  {firstErrors?.imageError && (
                    <Typography
                      style={{
                        paddingLeft: 15,
                        paddingRight: 15,
                        fontSize: '11px',
                        marginTop: '0.75rem'
                      }}
                      color="red"
                    >
                      {firstErrors?.imageError}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={2}>
                  <Button
                    id="btn-handleImageChange"
                    style={{
                      marginTop: '1.2rem',
                      border: '1px solid #5569ff',
                      marginLeft: '-0.5rem',
                      color: '#5569ff',
                      padding: '6px 8px',
                      borderRadius: '6px',
                      fontSize: '13px',
                      fontWeight: 'normal'
                    }}
                  >
                    Choose
                    <input
                      type="file"
                      name="attachment"
                      id="upload-profile"
                      accept="image/png, image/gif, image/jpeg"
                      onChange={handleImageChange}
                    />
                  </Button>
                </Grid>
              </Fragment>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={{ ml: 2, mt: 5 }}>
                <Typography style={titleStyles}>Contact Details</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Phone<span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl fullWidth>
                {/* <input type="text" disabled className="inputStyle" style={{ marginLeft: '15px', marginRight: '15px'}}  placeholder='---' id='phoneNumber'/> */}
                <MuiPhoneNumber defaultCountry={'lk'} 
                  size="small"
                  id="phoneNumber"
                  {...register('phoneNumber', {})}
                  InputProps={{
                    style: { fontSize: '12px', height: '2.25rem' }
                  }}
                  style={TextFieldStyle}
                  fullWidth
                  type="text"
                  placeholder="Enter Phone"
                  variant="outlined"
                  value={firstPageValidation.phone}
                  onChange={(e) => {
                    if (e.length < 16) {
                      setFirstErros((prev) => ({
                        ...prev,
                        phoneError: ''
                      }));
                      setFirstPageValidation((prev) => ({
                        ...prev,
                        phone: e
                      }));
                    }
                  }}
                />
                </FormControl>
                {firstErrors?.phoneError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {firstErrors?.phoneError}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Emergency Phone<span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl fullWidth>
                {/* <input type="text" disabled className="inputStyle" style={{ marginLeft: '15px', marginRight: '15px'}}  placeholder='---' id='emergencyContactNumber'/> */}
                <MuiPhoneNumber defaultCountry={'lk'} 
                  size="small"
                  id="emergencyContactNumber"
                  {...register('emergencyContactNumber', {})}
                  InputProps={{
                    style: { fontSize: '12px', height: '2.25rem' }
                  }}
                  style={TextFieldStyle}
                  fullWidth
                  type="text"
                  placeholder="Enter Phone"
                  variant="outlined"
                  value={firstPageValidation.ePhone}
                  onChange={(e) => {
                    if (e.length < 16) {
                      setFirstErros((prev) => ({
                        ...prev,
                        ePhoneError: ''
                      }));
                      setFirstPageValidation((prev) => ({
                        ...prev,
                        ePhone: e
                      }));
                    }
                  }}
                />
                </FormControl>
                {firstErrors?.ePhoneError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {firstErrors?.ePhoneError}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Permanent Address<span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl fullWidth>
                {/* <input type="text" disabled className="inputStyle" style={{ marginLeft: '15px', marginRight: '15px'}}  placeholder='---' id='address'/> */}
                <TextField
                  {...register('address', {})}
                  InputProps={{
                    style: { fontSize: '12px' }
                  }}
                  id="address"
                  multiline
                  size="small"
                  style={TextFieldStyle}
                  fullWidth
                  placeholder="Enter Address"
                  variant="outlined"
                  onChange={(e) => {
                    setFirstErros((prev) => ({
                      ...prev,
                      addressError: ''
                    }));
                    setFirstPageValidation((prev) => ({
                      ...prev,
                      address: e.target.value
                    }));
                  }}
                />
                </FormControl>
                {firstErrors?.addressError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {firstErrors?.addressError}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Current Address<span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl fullWidth>
                {/* <input type="text" disabled className="inputStyle" style={{ marginLeft: '15px', marginRight: '15px'}}  placeholder='---' id='currentAddress'/> */}
                <TextField
                  size="small"
                  {...register('currentAddress', {})}
                  InputProps={{
                    style: { fontSize: '12px' }
                  }}
                  id="currentAddress"
                  style={TextFieldStyle}
                  fullWidth
                  multiline
                  placeholder="Enter Current Address"
                  variant="outlined"
                  onChange={(e) => {
                    setFirstErros((prev) => ({
                      ...prev,
                      cAddressError: ''
                    }));
                    setFirstPageValidation((prev) => ({
                      ...prev,
                      cAddress: e.target.value
                    }));
                  }}
                />
                </FormControl>
                {firstErrors?.cAddressError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {firstErrors?.cAddressError}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Skype ID
                </Typography>
                <FormControl fullWidth>
                {/* <input type="text" disabled className="inputStyle" style={{ marginLeft: '15px', marginRight: '15px'}}  placeholder='---' id='skypeID'/> */}
                <TextField
                  size="small"
                  {...register('skypeID', {})}
                  InputProps={{
                    style: { fontSize: '12px', height: '2.25rem' }
                  }}
                  id="skypeID"
                  style={TextFieldStyle}
                  fullWidth
                  placeholder="Enter Skype ID"
                  variant="outlined"
                  onChange={(e) => {
                    setFirstErros((prev) => ({
                      ...prev,
                      skypeIdError: ''
                    }));
                    setFirstPageValidation((prev) => ({
                      ...prev,
                      skypeId: e.target.value.trim()
                    }));
                  }}
                />
                </FormControl>
                {firstErrors?.skypeIdError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {firstErrors?.skypeIdError}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Official Email Address<span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  size="small"
                  {...register('email', {})}
                  InputProps={{
                    style: { fontSize: '12px', height: '2.25rem' }
                  }}
                  id="email"
                  style={TextFieldStyle}
                  fullWidth
                  placeholder="Enter Email Address"
                  variant="outlined"
                  value={firstPageValidation.email}
                  onChange={(e) => {
                    setFirstErros((prev) => ({
                      ...prev,
                      emailError: ''
                    }));
                    setFirstPageValidation((prev) => ({
                      ...prev,
                      email: e.target.value
                    }));
                  }}
                />
                {firstErrors?.emailError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {firstErrors?.emailError}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Emergency Contact Person<span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl fullWidth>
                {/* <input type="text" disabled className="inputStyle" style={{ marginLeft: '15px', marginRight: '15px'}}  placeholder='---' id='emergencyContactName'/> */}
                <TextField
                  {...register('emergencyContactName', {})}
                  InputProps={{
                    style: { fontSize: '12px' }
                  }}
                  id="emergencyContactName"
                  size="small"
                  style={TextFieldStyle}
                  fullWidth
                  placeholder="Enter Emergency Contact Person"
                  variant="outlined"
                  multiline
                  value={firstPageValidation.ePhoneName}
                  onChange={(e) => {
                    if (e.target.value.length < 51) {
                      setFirstErros((prev) => ({
                        ...prev,
                        ePhoneNameError: ''
                      }));
                      setFirstPageValidation((prev) => ({
                        ...prev,
                        ePhoneName: e.target.value
                      }));
                    }
                  }}
                />
                </FormControl>
                {firstErrors?.ePhoneNameError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {firstErrors?.ePhoneNameError}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={6}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Emergency Contact Relationship<span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl fullWidth>
                {/* <input type="text" disabled className="inputStyle" style={{ marginLeft: '15px', marginRight: '15px'}}  placeholder='---' id='emergencyContactRelation'/> */}
                <TextField
                  {...register('emergencyContactRelation', {})}
                  InputProps={{
                    style: { fontSize: '12px', height: '2.25rem' }
                  }}
                  id="emergencyContactRelation"
                  size="small"
                  style={TextFieldStyle}
                  fullWidth
                  placeholder="Enter Contact Relationship"
                  variant="outlined"
                  value={firstPageValidation.ePhoneRelation}
                  onChange={(e) => {
                    if (e.target.value.length < 31) {
                      setFirstErros((prev) => ({
                        ...prev,
                        ePhoneRelationError: ''
                      }));
                      setFirstPageValidation((prev) => ({
                        ...prev,
                        ePhoneRelation: e.target.value
                      }));
                    }
                  }}
                />
                </FormControl>
                {firstErrors?.ePhoneRelationError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {firstErrors?.ePhoneRelationError}
                  </Typography>
                )}
              </Grid>
              <Grid container spacing={2}>
                <Divider />
                <Grid item xs={6}></Grid>

                <Grid
                  style={{
                    marginTop: '3rem',
                    paddingRight: '2rem',
                    marginBottom: '1rem'
                  }}
                  item
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end'
                  }}
                  xs={6}
                >
                  <Button
                    id="btn-handleClose"
                    style={{
                      width: '30%',
                      background: '#F5F7FF',
                      fontSize: '13px',
                      fontWeight: 'normal'
                    }}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    id="btn-handleSubmitSectionOne"
                    style={{
                      fontSize: '13px',
                      fontWeight: 'normal',
                      background: '#0069E4',
                      marginLeft: '1rem',
                      width: '30%'
                    }}
                    variant="contained"
                    type="button"
                    onClick={handleSubmitSectionOne}
                  >
                    Next
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
        {isNextSectionSelected === 2 && (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={{ mt: 4, pb: 1, pl: 2, ml: 2 }}>
                <Typography style={titleStyles}>Employment Details</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography fontWeight="light" style={LabelStyle} variant="h5">
                  Designation<span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl fullWidth>
                  <Select
                    MenuProps={{ autoFocus: false }}
                    labelId="search-select-label"
                    {...register('designation', {})}
                    style={{
                      height: '2.25rem',
                      width: '94%',
                      marginLeft: 15,
                      marginTop: 5,
                      paddingRight: 15,
                      fontSize: '13px'
                    }}
                    id="designation"
                    displayEmpty
                    defaultValue=""
                    value={selectedOption || ''}
                    onChange={(e) => {
                      const role = billingRoles.filter(
                        (r) => r.name === e.target.value
                      )[0];
                      setSecondPageValidation((prev) => ({
                        ...prev,
                        tier: role?.tier
                      }));
                      setSelectedOption(e.target.value);
                      setSecondErros((prev) => ({
                        ...prev,
                        designationError: ''
                      }));
                      setSecondPageValidation((prev) => ({
                        ...prev,
                        designation: e.target.value
                      }));
                    }}
                    onClose={() => setSearchText('')}
                  >
                    <ListSubheader>
                      <TextField
                        id="searchDesignation"
                        size="small"
                        // Autofocus on textfield
                        autoFocus
                        placeholder="Type to search..."
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          )
                        }}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                        }}
                        onKeyDown={(e) => {
                          if (e.key !== 'Escape') {
                            // Prevents autoselecting item while typing (default Select behaviour)
                            e.stopPropagation();
                          }
                        }}
                      />
                    </ListSubheader>
                    <MenuItem
                      style={{ display: 'none' }}
                      selected
                      disabled
                      value={''}
                    >
                      Select Designation
                    </MenuItem>
                    {displayedOptions.length > 0 &&
                      displayedOptions?.map((option, i) => (
                        <MenuItem key={i} value={option.name}>
                          {option.name}
                        </MenuItem>
                      ))}
                  </Select>
                  {secondErrors?.designationError && (
                    <Typography
                      style={{
                        paddingLeft: 15,
                        paddingRight: 15,
                        fontSize: '11px'
                      }}
                      color="red"
                    >
                      {secondErrors?.designationError}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Employee ID<span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  size="small"
                  {...register('employeeId', {})}
                  InputProps={{
                    style: { fontSize: '12px', height: '2.25rem' }
                  }}
                  disabled={isAutoFilled}
                  id="employeeId"
                  style={TextFieldStyle}
                  fullWidth
                  placeholder="Enter Internal Employee ID"
                  variant="outlined"
                  value={isAutoFilled ? secondPageValidation.employeeId : employeeId}
                  onChange={(e) => {
                    if (e.target.value.length < 11) {
                      setSecondPageValidation((prev) => ({
                        ...prev,
                        employeeId: e.target.value
                      }));
                      setEmployeeId(e.target.value);
                    }
                    setSecondErros((prev) => ({
                      ...prev,
                      employeeIdError: ''
                    }));
                  }}
                />
                {secondErrors?.employeeIdError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {secondErrors?.employeeIdError}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={6}>
                <Typography fontWeight="light" style={LabelStyle} variant="h5">
                  Tier<span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl fullWidth>
                  <TextField
                    size="small"
                    disabled
                    {...register('tier', {})}
                    id="tier"
                    style={TextFieldStyle}
                    value={secondPageValidation.tier}
                    placeholder="Tier"
                  />

                  {secondErrors?.tierError && (
                    <Typography
                      style={{
                        paddingLeft: 15,
                        paddingRight: 15,
                        fontSize: '11px'
                      }}
                      color="red"
                    >
                      {secondErrors?.tierError}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Joined Date<span style={{ color: 'red' }}>*</span>
                </Typography>
                <div style={{ marginLeft: 15, marginRight: 14, marginTop: 2 }}>
                  <FormControl fullWidth>
                    <DatePicker
                      InputProps={{
                        className: 'date-picker'
                      }}
                      renderInput={(params) => (
                        <TextField {...params} id="joinedDate" />
                      )}
                      value={
                        secondPageValidation?.joinedDate ? secondPageValidation.joinedDate : ''
                      }
                      onChange={(newValue) => {
                        if (newValue) {
                          setSecondErros((prev) => ({
                            ...prev,
                            joinError: ''
                          }));
                          setSecondPageValidation((prev) => ({
                            ...prev,
                            joinedDate: moment(newValue).format('YYYY-MM-DD')
                          }));
                          setValue('joinedDate', moment(newValue).format('YYYY-MM-DD'))
                        }
                      }}
                    />
                  </FormControl>
                </div>
                {secondErrors?.joinError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {secondErrors?.joinError}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                Career Start Date
                </Typography>
                <div style={{ marginLeft: 15, marginRight: 14, marginTop: 2 }}>
                  <FormControl fullWidth>
                    <DatePicker
                      disabled={!secondPageValidation?.joinedDate}
                      InputProps={{
                        className: 'date-picker'
                      }}
                      maxDate={new Date(secondPageValidation?.joinedDate)}
                      renderInput={(params) => (
                        <TextField {...params} id="carrierStartDate" />
                      )}
                      value={
                        secondPageValidation?.carrierStartDate ? secondPageValidation.carrierStartDate : ''
                      }
                      onChange={(newValue) => {
                        if (newValue) {
                          setSecondPageValidation((prev) => ({
                            ...prev,
                            carrierStartDate: moment(newValue).format('YYYY-MM-DD')
                          }));
                        }
                      }}
                    />
                  </FormControl>
                </div>
              </Grid>
              <Grid item xs={12} sx={{ mt: 2, pb: 1, pl: 2, ml: 2 }}>
                <Typography style={titleStyles}>Reporting Managers</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography fontWeight="light" style={LabelStyle} variant="h5">
                  Primary Reporting Manager<span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl fullWidth>
                  <Select
                    MenuProps={{ autoFocus: false }}
                    {...register('primaryManager')}
                    id="primaryManager"
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    defaultValue={''}
                    className="text-primary"
                    style={selectStyle}
                    size="small"
                    placeholder="Select Primary Reporting Manager"
                    value={selectedReporter || ''}
                    onChange={(e) => {
                      setPrimaryManager({
                        ReporterId: e.target.value,
                        Level: 'primary'
                      });
                      setSecondErros((prev) => ({
                        ...prev,
                        primaryManagerError: ''
                      }));
                      setSecondPageValidation((prev) => ({
                        ...prev,
                        primaryManager: e.target.value
                      }));

                      setSelectedReporter(e.target.value)
                    }}
                    onClose={() => setSearchText('')}
                  ><ListSubheader>
                  <TextField 
                   id="searchPrimaryManager"
                   size="small"
                   autoFocus
                   placeholder="Type to search..."
                   fullWidth
                   InputProps={{
                    startAdornment:(
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    )
                   }}
                   onChange={(e) => setSearchText(e.target.value)}
                   onKeyDown={(e) => {
                   if (e.key !== 'Escape') {
                   e.stopPropagation();
                   }}}
                   >  
                   </TextField>
                   </ListSubheader>
                    <MenuItem
                      style={{ display: 'none' }}
                      selected
                      disabled
                      value={''}
                    >
                      {'Select Primary Reporting Manager'}
                    </MenuItem>
                    {displayedReportingManagers.length > 0 && 
                    displayedReportingManagers?.map((option, i) => (
                      <MenuItem key={option.employeeId} value={option.employeeId}>
                        {option.name}
                      </MenuItem>
                      ))}
                  </Select>
                  {secondErrors?.primaryManagerError && (
                    <Typography
                      style={{
                        paddingLeft: 15,
                        paddingRight: 15,
                        fontSize: '11px'
                      }}
                      color="red"
                    >
                      {secondErrors?.primaryManagerError}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} sx={{ mt: 2, pb: 1, pl: 2, ml: 2 }}>
                <Typography style={titleStyles}>Employment Type</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Type<span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl fullWidth>
                  <Select
                    size="small"
                    {...register('employeeType', {})}
                    id="employeeType"
                    style={selectStyle}
                    displayEmpty
                    defaultValue={''}
                    value={selectedType}
                    onChange={(e) => {
                      setSecondErros((prev) => ({
                        ...prev,
                        employementTypeError: ''
                      }));
                      setSecondPageValidation((prev) => ({
                        ...prev,
                        employementType: e.target.value
                      }));
                      setSelectedType(e.target.value)
                    }}
                  >
                    <MenuItem
                      style={{ display: 'none' }}
                      selected
                      disabled
                      value={''}
                    >
                      Select Employment Type
                    </MenuItem>
                    <MenuItem value={'Permanent'} key={'Permanent'}>
                      Permanent
                    </MenuItem>
                    <MenuItem value={'Probation'} key={'Probation'}>
                      Probation
                    </MenuItem>
                    <MenuItem value={'Intern'} key={'Intern'}>
                      Intern
                    </MenuItem>
                  </Select>
                  {secondErrors?.employementTypeError && (
                    <Typography
                      style={{
                        paddingLeft: 15,
                        paddingRight: 15,
                        fontSize: '11px'
                      }}
                      color="red"
                    >
                      {secondErrors?.employementTypeError}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Typography style={LabelStyle} color="GrayText">
                  From<span style={{ color: 'red' }}>*</span>
                </Typography>
                <div style={{ marginLeft: 15, marginRight: 14, marginTop: 2 }}>
                  <FormControl fullWidth>
                    <DatePicker
                      InputProps={{
                        className: 'date-picker'
                      }}
                      minDate={new Date(secondPageValidation.joinedDate)}
                      renderInput={(params) => (
                        <TextField {...params} id="EmployeeTypeStartingDate" />
                      )}
                      value={
                        secondPageValidation?.from ? secondPageValidation.from : ''
                      }
                      onChange={(newValue) => {
                        if (newValue) {
                          setSecondErros((prev) => ({
                            ...prev,
                            fromError: ''
                          }));
                          setSecondPageValidation((prev) => ({
                            ...prev,
                            from: moment(newValue).format('YYYY-MM-DD')
                          }));
                          setValue('EmployeeTypeStartingDate', moment(newValue).format('YYYY-MM-DD'))
                        }
                      }}
                    />
                  </FormControl>
                </div>
                {secondErrors?.fromError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {secondErrors?.fromError}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography style={LabelStyle} color="GrayText">
                  To
                </Typography>
                <div style={{ marginLeft: 15, marginRight: 14, marginTop: 2 }}>
                  <FormControl fullWidth>
                    <DatePicker
                      InputProps={{
                        className: 'date-picker'
                      }}
                      minDate={new Date(secondPageValidation.from)}
                      renderInput={(params) => (
                        <TextField {...params} id="EmployeeTypeEndingDate" />
                      )}
                      value={
                        secondPageValidation?.to ? secondPageValidation.to : ''
                      }
                      onChange={(newValue) => {
                        if (newValue) {
                          setSecondErros((prev) => ({
                            ...prev,
                            toError: ''
                          }));
                          setSecondPageValidation((prev) => ({
                            ...prev,
                            to: moment(newValue).format('YYYY-MM-DD')
                          }));
                          setValue('EmployeeTypeEndingDate', moment(newValue).format('YYYY-MM-DD'))
                        }
                      }}
                    />
                  </FormControl>
                </div>
                {secondErrors?.toError && (
                  <Typography
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px'
                    }}
                    color="red"
                  >
                    {secondErrors?.toError}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Divider />
              <Grid item xs={6}></Grid>
              <Grid
                item
                sx={{
                  mb: 2,
                  mt: 2,
                  pr: 2,
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}
                xs={6}
              >
                <Button
                  sx={{
                    width: '30%',
                    background: '#F5F7FF',
                    fontSize: '13px',
                    fontWeight: 'normal'
                  }}
                  onClick={handleBackClick}
                  id="btn-handleBackClick"
                >
                  Back
                </Button>
                <Button
                  id="btn-handleSubmitSectionTwo"
                  sx={{
                    ml: 2,
                    width: '30%',
                    fontSize: '13px',
                    fontWeight: 'normal',
                    background: '#0069E4'
                  }}
                  variant="contained"
                  type="button"
                  onClick={handleSubmitSectionTwo}
                >
                  Next
                </Button>
              </Grid>
            </Grid>
          </>
        )}
        {isNextSectionSelected === 3 && (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={{ mt: 4, pb: 1, pl: 2, ml: 2 }}>
                <Typography style={titleStyles}>Banking Details</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography fontWeight="light" style={LabelStyle} variant="h5">
                  Bank Name
                </Typography>
                <FormControl fullWidth>
                <input type="text" disabled className="inputStyle" style={{ marginLeft: '15px', marginRight: '15px'}}  placeholder='---' id='bankName'/>
                  {/* <Autocomplete
                    disabled
                    fullWidth
                    style={TextFieldStyle}
                    value={bankValue}
                    // {...register('bankName', {})}
                    id="bankName"
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        setBankValue({
                          title: newValue
                        });
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setBankValue({
                          title: newValue.inputValue
                        });
                      } else {
                        setBankValue(newValue);
                      }
                      setThirdErros((prev) => ({
                        ...prev,
                        bankNameError: ''
                      }));

                      setThirdPageValidation((prev) => ({
                        ...prev,
                        bankName: newValue
                      }));
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      const { inputValue } = params;
                      // Suggest the creation of a new value
                      const isExisting = options.some(
                        (option) => inputValue === option.title
                      );
                      if (
                        inputValue !== '' &&
                        !isExisting &&
                        inputValue.trim().length > 0
                      ) {
                        filtered.push({
                          inputValue,
                          title: `Add "${inputValue}"`
                        });
                      }
                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    options={allBanks}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      // Regular option
                      return option.title;
                    }}
                    renderOption={(props, option) => (
                      <li {...props}>{option.title}</li>
                    )}
                    freeSolo
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        // value={bankValue}
                        // {...register('bankName', {})}
                        placeholder="Bank Name"
                      />
                    )}
                    size="small"
                  /> */}
                  {thirdErrors?.bankNameError && (
                    <Typography
                      style={{
                        paddingLeft: 15,
                        paddingRight: 15,
                        fontSize: '11px'
                      }}
                      color="red"
                    >
                      {thirdErrors?.bankNameError}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Typography fontWeight="light" style={LabelStyle} variant="h5">
                  Branch Code
                </Typography>
                <FormControl fullWidth>
                  {/* <TextField
                    disabled
                    {...register('branchCode', {})}
                    InputProps={{
                      style: { fontSize: '12px', height: '2.25rem' }
                    }}
                    id="branchCode"
                    size="small"
                    style={TextFieldStyle}
                    fullWidth
                    type="number"
                    placeholder="---"
                    variant="outlined"
                    value={Number(thirdPageValidation.branchCode) || ''}
                    onChange={(e) => {
                      if (e.target.value.length < 11) {
                        setThirdErros((prev) => ({
                          ...prev,
                          branchCodeError: ''
                        }));
                        setThirdPageValidation((prev) => ({
                          ...prev,
                          branchCode: e.target.value
                        }));
                      }
                    }}
                  /> */}
                  <input type="text" disabled className="inputStyle" style={{ marginLeft: '15px', marginRight: '15px'}}  placeholder='---' id='branchCode'/>
                  {thirdErrors?.branchCodeError && (
                    <Typography
                      style={{
                        paddingLeft: 15,
                        paddingRight: 15,
                        fontSize: '11px'
                      }}
                      color="red"
                    >
                      {thirdErrors?.branchCodeError}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Typography fontWeight="light" style={LabelStyle} variant="h5">
                  Branch
                </Typography>
                <FormControl fullWidth>
                  {/* <TextField
                    disabled
                    size="small"
                    {...register('branch', {})}
                    InputProps={{
                      style: { fontSize: '12px', height: '2.25rem' }
                    }}
                    id="branch"
                    style={TextFieldStyle}
                    fullWidth
                    placeholder="---"
                    variant="outlined"
                    value={thirdPageValidation.branch}
                    onChange={(e) => {
                      if (e.target.value.length < 51) {
                        setThirdErros((prev) => ({
                          ...prev,
                          branchError: ''
                        }));
                        setThirdPageValidation((prev) => ({
                          ...prev,
                          branch: e.target.value
                        }));
                      }
                    }}
                  /> */}
                  <input type="text" disabled className="inputStyle" style={{ marginLeft: '15px', marginRight: '15px'}}  placeholder='---' id='branch'/>
                  {thirdErrors?.branchError && (
                    <Typography
                      style={{
                        paddingLeft: 15,
                        paddingRight: 15,
                        fontSize: '11px'
                      }}
                      color="red"
                    >
                      {thirdErrors?.branchError}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Typography fontWeight="light" style={LabelStyle} variant="h5">
                  Account Name
                </Typography>
                <FormControl fullWidth>
                  {/* <TextField
                    disabled
                    {...register('accountName', {})}
                    InputProps={{
                      style: { fontSize: '12px', height: '2.25rem' }
                    }}
                    id="accountName"
                    size="small"
                    style={TextFieldStyle}
                    fullWidth
                    placeholder="---"
                    variant="outlined"
                    onChange={(e) => {
                      setThirdErros((prev) => ({
                        ...prev,
                        accountNameError: ''
                      }));
                      setThirdPageValidation((prev) => ({
                        ...prev,
                        accountName: e.target.value
                      }));
                    }}
                  /> */}
                  <input type="text" disabled className="inputStyle" style={{ marginLeft: '15px', marginRight: '15px'}}  placeholder='---' id='accountName'/>
                  {thirdErrors?.accountNameError && (
                    <Typography
                      style={{
                        paddingLeft: 15,
                        paddingRight: 15,
                        fontSize: '11px'
                      }}
                      color="red"
                    >
                      {thirdErrors?.accountNameError}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <Typography fontWeight="light" style={LabelStyle} variant="h5">
                  Account Number
                </Typography>
                <FormControl fullWidth>
                  {/* <TextField
                    disabled
                    {...register('accountNumber', {})}
                    InputProps={{
                      style: { fontSize: '12px', height: '2.25rem' }
                    }}
                    id="accountNumber"
                    size="small"
                    style={TextFieldStyle}
                    fullWidth
                    type="number"
                    placeholder="---"
                    variant="outlined"
                    value={thirdPageValidation.accountNumber}
                    onChange={(e) => {
                      if (e.target.value.length < 31) {
                        setThirdErros((prev) => ({
                          ...prev,
                          accountNumberError: ''
                        }));
                        setThirdPageValidation((prev) => ({
                          ...prev,
                          accountNumber: e.target.value
                        }));
                      }
                    }}
                  /> */}
                  <input type="text" disabled className="inputStyle" style={{ marginLeft: '15px', marginRight: '15px'}}  placeholder='---' id='accountNumber'/>
                  {thirdErrors?.accountNumberError && (
                    <Typography
                      style={{
                        paddingLeft: 15,
                        paddingRight: 15,
                        fontSize: '11px'
                      }}
                      color="red"
                    >
                      {thirdErrors?.accountNumberError}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6}></Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={{ mt: 2, pb: 1, pl: 2, ml: 2 }}>
                <Typography style={titleStyles}>
                  User Account Details
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography fontWeight="light" style={LabelStyle} variant="h5">
                  User Role<span style={{ color: 'red' }}>*</span>
                </Typography>
                <FormControl fullWidth>
                  <Multiselect
                    {...register('role', {})}
                    selectedValues={setSelectedRoles()}
                    className='user-role-multi-select'
                    style={{
                      multiselectListContainer:{
                        paddingRight: 30,
                      },
                      multiselectContainer: {
                        paddingLeft: 15,
                        paddingRight: 15,
                        width: '100%'
                      }
                    }}
                    id="role"
                    /* key={resetKey} */
                    placeholder={'Select User Role'}
                    options={userRoles.map((role) => ({
                      ...role,
                      disabled: role.name === "General User"
                    }))}
                    onSelect={onSelect}
                    onRemove={(selectedList, removedItem) => {
                      if (removedItem.name === "General User") return;
                      onRemove(selectedList, removedItem);
                    }}
                    displayValue="name"
                  />
                  {/* <Select
                    size="small"
                    {...register('role', {})}
                    id="role"
                    style={selectStyle}
                    displayEmpty
                    defaultValue={''}
                    value={selectedUserRole}
                    onChange={(e) => {
                      setThirdErros((prev) => ({
                        ...prev,
                        userRoleError: ''
                      }));
                      setThirdPageValidation((prev) => ({
                        ...prev,
                        userRole: e.target.value
                      }));
                      setSelectedUserRole(e.target.value)
                    }}
                  >
                    <MenuItem
                      style={{ display: 'none' }}
                      selected
                      disabled
                      value={''}
                    >
                      Select User Role
                    </MenuItem>
                    {(userRoles || []).map((item: any) => {
                      return (
                        <MenuItem value={item?.name} key={item?.roleId}>
                          {item?.name}
                        </MenuItem>
                      );
                    })}
                  </Select> */}
                  {thirdErrors?.userRoleError && (
                    <Typography
                      style={{
                        paddingLeft: 15,
                        paddingRight: 15,
                        fontSize: '11px'
                      }}
                      color="red"
                    >
                      {thirdErrors?.userRoleError}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControlLabel
                  style={TextFieldStyle}
                  control={<Checkbox {...register('createJiraAccount')} />}
                  id="createJiraAccount"
                  label={
                    <Typography style={{ fontSize: '12px' }}>
                      Jira account required
                    </Typography>
                  }
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControlLabel
                  style={TextFieldStyle}
                  control={<Checkbox {...register('jiraLead')} />}
                  id="jiraLead"
                  label={
                    <Typography style={{ fontSize: '12px' }}>
                      Jira lead
                    </Typography>
                  }
                />
              </Grid>
            </Grid>

            <Grid display="flex" item xs={12}>
              <Grid item xs={6}>
                <Typography fontWeight="light" style={LabelStyle} variant="h5">
                  Skill
                </Typography>
                <FormControl fullWidth>
                  <Autocomplete
                    id='skill'
                    fullWidth
                    style={TextFieldStyle}
                    value={skill}
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        setSkill({
                          title: newValue
                        });
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setSkill({
                          title: newValue.inputValue
                        });
                      } else {
                        setSkill(newValue);
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      const { inputValue } = params;
                      // Suggest the creation of a new value
                      const isExisting = options.some(
                        (option) => inputValue === option.title
                      );
                      if (
                        inputValue !== '' &&
                        !isExisting &&
                        inputValue.trim().length > 0
                      ) {
                        filtered.push({
                          inputValue,
                          title: `Add "${inputValue}"`
                        });
                      }
                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    options={allSkills}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      // Regular option
                      return option.title;
                    }}
                    renderOption={(props, option) => (
                      <li {...props}>{option.title}</li>
                    )}
                    freeSolo
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Enter Skill" />
                    )}
                    size="small"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <Typography fontWeight="light" style={LabelStyle} variant="h5">
                  Level
                </Typography>
                <StyledRating
                  id='rating'
                  sx={{ pt: '0.65rem' }}
                  name="customized-color"
                  defaultValue={rating}
                  value={rating}
                  onChange={(event, newValue) => {
                    setRating(newValue);
                  }}
                  precision={1}
                  icon={<CircleIcon fontSize="small" />}
                  emptyIcon={<CircleIcon fontSize="small" />}
                />
              </Grid>
              <Grid
                display="flex"
                flexDirection="column"
                justifyContent="end"
                item
                xs={2}
              >
                <Button
                  id="btn-addSkill"
                  disabled={!skill}
                  type="button"
                  onClick={() => addSkill()}
                  sx={{ width: '40%', mt: '1.25rem', mr: 3, ml: 'auto' }}
                  variant="contained"
                >
                  Add
                </Button>
                {duplicateError && (
                  <Typography
                    style={{ marginLeft: '0.75rem' }}
                    sx={{ color: 'red' }}
                    variant="body2"
                  >
                    {duplicateError}
                  </Typography>
                )}
              </Grid>
            </Grid>

            {addedSkills?.length > 0 &&
              addedSkills.map((skill, i) => (
                <Grid display="flex" alignItems="center" item xs={12}>
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <TextField
                        id={"skillName" + i}
                        disabled
                        size="small"
                        style={TextFieldStyle}
                        InputProps={{
                          style: { fontSize: '12px', height: '2.25rem' }
                        }}
                        fullWidth
                        variant="outlined"
                        value={skill.name}
                        aria-readonly
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <StyledRating
                      id={"skillLevel" + i}
                      sx={{ pt: '0.65rem' }}
                      name="customized-color"
                      defaultValue={skill.level}
                      disabled
                      precision={1}
                      icon={<CircleIcon fontSize="small" />}
                      emptyIcon={<CircleIcon fontSize="small" />}
                    />
                  </Grid>
                  <Grid display="flex" justifyContent="end" item xs={2}>
                    <CancelIcon
                      id={"btn-setAddedSkills" + i}
                      sx={{ mr: 3, cursor: 'pointer' }}
                      fontSize="small"
                      color="action"
                      onClick={() =>
                        setAddedSkills(
                          addedSkills.filter((ad) => ad.id !== skill.id)
                        )
                      }
                    />
                  </Grid>
                </Grid>
              ))}
            <Grid container spacing={2}>
              <Divider />
              <Grid item xs={6}></Grid>
              <Grid
                item
                sx={{
                  mb: 2,
                  mt: 2,
                  pr: 2,
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}
                xs={6}
              >
                <Button
                  id="btn-handleBackClick"
                  sx={{
                    width: '30%',
                    background: '#F5F7FF',
                    fontSize: '13px',
                    fontWeight: 'normal'
                  }}
                  onClick={handleBackClick}
                >
                  Back
                </Button>
                <Button
                  disabled={isLoading}
                  className={isLoading ? 'loading' : ''}
                  id="btn-onSubmit"
                  type="submit"
                  sx={{
                    ml: 2,
                    width: '30%',
                    fontSize: '13px',
                    fontWeight: 'normal',
                    background: '#0069E4'
                  }}
                  variant="contained"
                >
                  Add
                </Button>
              </Grid>
            </Grid>
          </>
        )}
      </form>
      <ConfirmationModal
        isLoading={isLoading}
        open={openConfirmation}
        toggle={toggleConfirmation}
        message={`Are you sure you want to add new skill named "${skill?.title}"?`}
        onConfirm={() => {
          setAddedSkills([
            ...addedSkills,
            { name: skill.title, level: rating }
          ]);
          addSkillToList();
          toggleConfirmation();
        }}
        noToggle={toggleConfirmation}
      />
    </Dialog>
  );
}

EmployeeAddForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  getData: PropTypes.any
};

export default EmployeeAddForm;
